// axiosInstance.ts
import axios from 'axios';

const getToken=()=>{
    const cookies = document.cookie.split(";");
    let jwtCookie = null;

    // `.trim().startsWith("token=")` instead of `.includes("token=")`
    // so cookies like `refresh_token=`, `g_csrf_token=`, `xsrf_token=`
    // don't poison the match. The substring check was overwriting the
    // real JWT with whatever token-like cookie appeared later in the
    // string, causing the BE to reject with "Auth failed".
    cookies.map((cookie) => {
      const c = cookie.trim();
      if (c.startsWith("token=")) {
        jwtCookie = "Bearer " + c.slice("token=".length);
      }
    //   return null;
    });
    return jwtCookie
}
// Create an instance of axios
const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL, // Replace with your API base URL
  // timeout: 5000, // Timeout after 5 seconds
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request Interceptor (Optional: Add token or modify requests globally)
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify request config before sending (e.g., add authorization header)
    const token = getToken(); // Example: Retrieve token from localStorage
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response Interceptor
// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Any status code within the range of 2xx triggers this function
//     return response;
//   },
//   (error) => {
//     // Handle response errors globally
//     if (error.response) {
//       // Server responded with a status outside the 2xx range
//       switch (error.response.status) {
//         case 401:
//           console.error('Unauthorized! Please login again.');
//           // Optionally redirect to login page or refresh token
//           break;
//         case 403:
//           console.error('Forbidden! You do not have access.');
//           break;
//         case 404:
//           console.error('Not Found! The resource does not exist.');
//           break;
//         case 500:
//           console.error('Server Error! Please try again later.');
//           break;
//         default:
//           console.error(`Error: ${error.response.data.message || 'Unknown error occurred'}`);
//       }
//     } else if (error.request) {
//       // Request was made but no response was received
//       console.error('No response received from the server.');
//     } else {
//       // Error setting up the request
//       console.error('Error:', error.message);
//     }

//     // Always reject the promise to handle the error downstream
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
